<style scoped>
/* Contenedor principal de la navegación */
.header-navigation-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* Alineación perfecta al centro */
  border-bottom: 1px solid #e5e5e5;
  /* La línea gris clara de la referencia */
  padding-bottom: 0;
  /* Importante para que el tab pise la línea */
}

.section-title {
  color: #06283c;
  font-size: 1rem;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.tabs-scroll-container {
  display: flex;
  gap: 25px;
  overflow-x: auto;
  scrollbar-width: none;
  flex-grow: 1;
  /* Esto permite que el contenedor crezca para poder centrar los hijos */
}

/* Opcional: Si quieres que el título se quede a la izquierda 
   y solo los tabs se centren en el espacio restante */
@media (min-width: 992px) {
  .tabs-scroll-container {
    justify-content: center;
  }
}

.tabs-scroll-container::-webkit-scrollbar {
  display: none;
  /* Oculta scroll en Chrome/Safari */
}

/* El Tab Estilo Minimalista */
.tab-minimal {
  background: none;
  border: none;
  padding: 12px 0;
  color: #999;
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
  position: relative;
  transition: color 0.3s ease;
  white-space: nowrap;
}

.tab-minimal:hover {
  color: #06283c;
}

/* El truco del Tab Activo */
.tab-minimal.active-tab {
  color: #ff9800;
  /* Naranja para resaltar el producto seleccionado */
}

.tab-minimal.active-tab::after {
  content: "";
  position: absolute;
  bottom: -1px;
  /* Justo encima de la línea del contenedor */
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #ff9800;
}

/* Controles del Slider */
.btn-control {
  background: white;
  border: 1px solid #ddd;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  border-radius: 2px;
}

.btn-control:hover {
  border-color: #06283c;
  background-color: #f8f9fa;
}

/* Iconos de flecha custom (sin imágenes/fuentes externas) */
.arrow-icon {
  width: 8px;
  height: 8px;
  border-top: 2px solid #555;
  border-right: 2px solid #555;
  display: inline-block;
}

.arrow-icon.left {
  transform: rotate(-135deg);
}

.arrow-icon.right {
  transform: rotate(45deg);
}

.btn-control-mobile {
  background: #f1f1f1;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  font-weight: bold;
}
</style>

<template>
  <div v-if="cantitemsbanner.length > 0" class="container my-5">
    <SectionTitle variant="accent" accent-bar title="<strong>PRODUCTOS</strong> ACTUALIZADOS" />

    <div class="d-flex align-items-center justify-content-between border-bottom mb-4">
      <div class="tabs-scroll-container justify-content-lg-center flex-grow-1">
        <button v-for="(sucursal, index) in prodsbanneroriginal.filter(s => s.Prods.length > 0)" :key="'tab-' + index"
          @click="changeTab(index)" class="tab-minimal" :class="{ 'active-tab': isActiveTab(index) }">
          {{ sucursal.nombre }}
        </button>
      </div>

      <div class="d-none d-md-flex gap-2 ms-3 pb-2">
        <button class="btn-control" @click="goToPrevious"> ← </button>
        <button class="btn-control" @click="goToNext"> → </button>
      </div>
    </div>

    <div v-if="mostrarCarousel" id="carouselBanner" ref="carouselEl" class="carousel slide" data-bs-ride="carousel">

      <div class="carousel-inner">
        <div class="carousel-item" v-for="(chunk, index) in chunkedProds" :key="'chunk-' + currentIndex + '-' + index"
          :class="{ active: index === 0 }">

          <div class="row g-4">
            <div class="col-12 col-md-6 col-lg-3 d-flex" v-for="producto in chunk" :key="producto.id">

              <Cardsprodspresentation :info="producto" class="w-100 card-hover-effect" />
            </div>
          </div>
        </div>
      </div>

      <div class="d-md-none mt-4 text-center">
        <button class="btn-control-mobile me-2" @click="goToPrevious">←</button>
        <button class="btn-control-mobile" @click="goToNext">→</button>
      </div>
    </div>
  </div>
</template>

<script>
import { nextTick } from 'vue';
import Carousel from 'bootstrap/js/dist/carousel';
import Cardsprodspresentation from "../../../Complements/Components/PresentacionProductos/cardsprods2.vue";
import SectionTitle from '../../../Complements/Components/Titleseccions.vue';

export default {
  components: {
    Cardsprodspresentation,
    SectionTitle
  },
  data() {
    return {
      prodsbanner: {},
      prodsbanneroriginal: [],
      cantitemsbanner: [],
      currentIndex: 0,
      carouselInstance: null,
      windowWidth: window.innerWidth,
      // ESTA ES LA CLAVE: Controla si el carrusel existe en el DOM
      mostrarCarousel: true
    };
  },
  computed: {
    itemsPerSlide() {
      if (this.windowWidth < 768) return 1;
      if (this.windowWidth < 992) return 2;
      return 4;
    },
    chunkedProds() {
      const chunks = [];
      if (!this.prodsbanner?.Prods) return chunks;

      for (let i = 0; i < this.prodsbanner.Prods.length; i += this.itemsPerSlide) {
        chunks.push(this.prodsbanner.Prods.slice(i, i + this.itemsPerSlide));
      }
      return chunks;
    },
    vehiculoSeleccionado() {
      return this.$store.getters.vehiculoSeleccionado;
    }
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
      // Re-inicializamos si cambia el tamaño
      this.$nextTick(() => this.initCarousel());
    },

    async changeTab(index) {
      // 1. Apagamos el carrusel para que desaparezca del DOM
      this.mostrarCarousel = false;

      // 2. Limpiamos la instancia vieja de Bootstrap
      if (this.carouselInstance) {
        this.carouselInstance.dispose();
        this.carouselInstance = null;
      }

      // 3. Cambiamos los productos a la nueva marca
      this.currentIndex = index;
      this.prodsbanner = this.prodsbanneroriginal[this.currentIndex];
      this.cantitemsbanner = this.prodsbanner?.Prods || [];

      // 4. Esperamos un tick para que Vue procese que el carrusel NO existe
      await nextTick();

      // 5. Volvemos a encender el carrusel (esto fuerza que inicie en slide 0)
      this.mostrarCarousel = true;

      // 6. Esperamos a que el HTML nuevo se dibuje y prendemos Bootstrap
      await nextTick();
      this.initCarousel();
    },

    isActiveTab(index) {
      return this.currentIndex === index;
    },

    async ObtenerProds() {
      try {
        const vehiculo = this.vehiculoSeleccionado;
        const response = await axios.get('/controllerpeticiones/prodsbanner', {
          params: { vehiculo: vehiculo ? JSON.stringify(vehiculo) : null }
        });

        this.prodsbanneroriginal = response.data.filtrado.filter(
          s => s.Prods && s.Prods.length
        );

        if (this.prodsbanneroriginal.length > 0) {
          this.prodsbanner = this.prodsbanneroriginal[this.currentIndex];
          this.cantitemsbanner = this.prodsbanner?.Prods || [];
          await nextTick();
          this.initCarousel();
        }
      } catch (e) {
        console.error(e);
      }
    },

    initCarousel() {
      const el = this.$refs.carouselEl;
      if (!el) return;

      // Si ya existe una instancia por un resize, la limpiamos
      if (this.carouselInstance) {
        this.carouselInstance.dispose();
      }

      this.carouselInstance = new Carousel(el, {
        interval: 4000,
        ride: 'carousel',
        wrap: true,
        touch: true
      });
    },

    goToPrevious() {
      this.carouselInstance?.prev();
    },
    goToNext() {
      this.carouselInstance?.next();
    }
  },
  mounted() {
    this.ObtenerProds();
    window.addEventListener('resize', this.onResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onResize);
    if (this.carouselInstance) {
      this.carouselInstance.dispose();
    }
  }
};
</script>